import React from 'react';
import { Icon } from '@magalu/stereo-ui-icons';
import { Container } from './styled';

const PageLoading = () => /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Icon, {
  name: "AnimatedLoadingColorful2",
  width: 50,
  height: 50
}));

export default PageLoading;